module.exports = __webpack_public_path__ + "static/media/feedlogic-1.a36690ac.jpg";